import { render, staticRenderFns } from "./OrderDispatch.vue?vue&type=template&id=23af306f&scoped=true"
import script from "./OrderDispatch.vue?vue&type=script&lang=js"
export * from "./OrderDispatch.vue?vue&type=script&lang=js"
import style0 from "./OrderDispatch.vue?vue&type=style&index=0&id=23af306f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af306f",
  null
  
)

export default component.exports